import { Card, CardBody, Col } from "reactstrap";
import { ShapesTitle } from "../../../constants";
import { AvatarShapeData, ShapesSubTitle } from "../../../data/uiKits/Avatars";
import { dynamicImage } from "../../../utils";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { Image } from "../../../coreComponents/Image";

const Shapes = () => {
  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={ShapesTitle} span={ShapesSubTitle} />
        <CardBody className="avatar-showcase">
          <div className="avatars">
            {AvatarShapeData &&
              AvatarShapeData.map((item, index) => (
                <div key={index} className="avatar">
                  <Image className={`img-${item.class}`} src={dynamicImage(`avtar/${item.image}`)} alt="user profile" />
                </div>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default Shapes;
